import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiGet, type Campaign } from "../api/client";
import { PageHeader } from "../components/PageHeader";

/**
 * Communications hub — historical `communications/communications.html`.
 * Tiles are full ne__tile cards (icon + name + optional count), not plain links.
 */
export function CommunicationsPage() {
  const [campaignCount, setCampaignCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    apiGet<{ campaigns: Campaign[] }>("/campaigns")
      .then((d) => {
        if (!cancelled) setCampaignCount((d?.campaigns ?? []).length);
      })
      .catch(() => {
        if (!cancelled) setCampaignCount(0);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <PageHeader title="Communications" />
      <div className="ne__communications">
        <ul className="ne__tile__grid">
          <li className="ne__tile ne__tile--primary">
            <Link className="ne__tile__button" to="/app/campaigns">
              <div className="ne__tile__content">
                <div className="ne__tile__body">
                  <i
                    className="ne__tile__icon ne__icon__megaphone--thinnest"
                    aria-hidden="true"
                  />
                  <h3 className="ne__tile__name">Campaigns</h3>
                </div>
                <div className="ne__tile__bottom">
                  <ul className="ne__tile__info">
                    <li className="ne__tile__count">
                      {campaignCount === null
                        ? "\u00a0"
                        : `${campaignCount} templates`}
                    </li>
                  </ul>
                </div>
              </div>
            </Link>
          </li>
          <li className="ne__tile ne__tile--primary">
            <Link className="ne__tile__button" to="/app/surveys">
              <div className="ne__tile__content">
                <div className="ne__tile__body">
                  <i
                    className="ne__tile__icon ne__icon__forms--thinnest"
                    aria-hidden="true"
                  />
                  <h3 className="ne__tile__name">Surveys</h3>
                </div>
              </div>
            </Link>
          </li>
        </ul>
        <p style={{ marginTop: "1.5rem" }}>
          <Link to="/app/communications/activity-log">Activity log</Link>
          {" · "}
          <Link to="/app/forms">Forms</Link>
        </p>
      </div>
    </>
  );
}
